import { IDevice } from '@pages/Assets/Inventory/types';
import { useCallback } from 'react';
import { IDeviceActionRequestPayload } from '../types';

interface AlgarBaitRenewalProps {
  devicesProps: IDevice[] | undefined;
  uploadedDevices: any;
  actionKey: number;
  handleDeviceActions: (item: IDeviceActionRequestPayload) => void;
}

const useAlgarBaitRenewal = ({
  actionKey,
  devicesProps,
  uploadedDevices,
  handleDeviceActions,
}: AlgarBaitRenewalProps) => {
  const contentSteps: [] = [];

  const onSubmit = useCallback(async () => {
    const payload: IDeviceActionRequestPayload = {};
    payload.action = actionKey;

    payload.devices =
      devicesProps && devicesProps.length > 0
        ? devicesProps?.map(device => ({
            msisdn: device.msisdn,
          }))
        : uploadedDevices;
    return handleDeviceActions(payload);
  }, [actionKey, devicesProps, uploadedDevices, handleDeviceActions]);

  const algarBaitRenewalData = {
    contentSteps,
    onSubmit,
  };

  return { algarBaitRenewalData };
};

export default useAlgarBaitRenewal;
